import { Box, Stack, Text, useComputedColorScheme } from "@mantine/core";
import { Fragment } from "react";

import MeqLogoDark from "~/assets/images/meq-logo-dark.png";
import MeqLogoLight from "~/assets/images/meq-logo-light.png";
import { Button, Dialog } from "~/components";
import { isWorkOSAuth } from "~/lib/authProvider";

import { DarkColorSchemeScope } from "./DarkColorSchemeScope";
import TermsOfServiceContent from "./TermsOfServiceContent";

const TermsOfServiceDialog = ({
  isOpen,
  onClose,
  onAccept,
  isAccepting,
}: {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  isAccepting: boolean;
}) => {
  const isWorkOS = isWorkOSAuth();
  // The WorkOS dialog sits over the dark-pinned splash while the app scheme
  // may be light — force the app's normal dark scheme there.
  const ColorSchemeScope = isWorkOS ? DarkColorSchemeScope : Fragment;
  const isDark = useComputedColorScheme("light") === "dark" || isWorkOS;

  return (
    <Dialog open={isOpen} onClose={onClose} fullScreen>
      <ColorSchemeScope>
        {/* `100dvh`, not `100%`: neither the fullScreen dialog body nor the
            dark scope has a definite height, so a percentage lets the terms
            grow the page and pushes Accept below the fold. */}
        <Stack h="100dvh" gap={0}>
          {/* Header */}
          <Box
            ta="center"
            py={24}
            px={24}
            bg="var(--mantine-color-bg-secondary)"
          >
            <img
              src={isDark ? MeqLogoDark : MeqLogoLight}
              alt="MEQ Insights"
              width={120}
              style={{ marginBottom: "16px" }}
            />
            <Text fz="1.25rem" fw={700}>
              Please confirm that you have read and accept the
            </Text>
            <Text fz="1.25rem" fw={700}>
              MEQ Insights Terms of Service.
            </Text>
          </Box>

          {/* Terms Content Container */}
          <Box
            bg="var(--mantine-color-bg-secondary)"
            style={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              overflow: "hidden", // Prevent outer container from scrolling
            }}
          >
            <Box
              maw={800}
              w="100%"
              h="100%"
              p={24}
              bg="var(--mantine-color-bg-primary)"
              style={{
                border: "10px solid var(--mantine-color-border-primary)",
                borderRadius: 4,
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <TermsOfServiceContent />
            </Box>
          </Box>

          {/* Fixed Footer with Accept Button */}
          <Box p={24} ta="center" bg="var(--mantine-color-bg-secondary)">
            <Button
              title="Accept"
              variant="filled"
              onClick={onAccept}
              loading={isAccepting}
            ></Button>
          </Box>
        </Stack>
      </ColorSchemeScope>
    </Dialog>
  );
};

export default TermsOfServiceDialog;
